import { cn } from '@1trading/react';

type LogoProps = {
  theme: 'dark' | 'light';
  className?: string;
};

export const Logo = ({ theme, className }: LogoProps) => (
  <a href="/" className={cn('focus-visible:outline-2 focus-visible:outline-ring', className)}>
    <img
      src={`${import.meta.env.VITE_APP_CDN_URL}/img/${theme === 'dark' ? 'onetrading-logo-rebrand-white.svg' : 'onetrading-logo-rebrand-blue-black.svg'}`}
      alt="One Trading"
      className="h-5.5 w-auto md:h-6.5"
    />
  </a>
);
